module.exports = __webpack_public_path__ + "img/Jump Casting13.63ed4e5c.jpg";